Px.Editor.MobileHeader = class MobileHeader extends Px.Editor.Header {

  template() {
    const store = this.data.store;
    const view_mode = store.mobile.view_mode;
    return Px.template`
      <header class="px-mobile-header px-header">
        <div class="px-mobile-header-main">
          ${Px.if(view_mode === 'edit' || view_mode === 'layout-selection', () => {
            return this.element_edit_template();
          }).elseIf(view_mode === 'autofill', () => {
            return this.autofill_panel_template();
          }).elseIf(view_mode === 'cut-prints-quantity-selection', () => {
            return this.cut_print_quantity_selection_template();
          }).elseIf(view_mode === 'set-selection', () => {
            return this.set_selection_template();
          }).elseIf(view_mode === 'selection', () => {
            // TODO: Not currently used
            return this.element_selection_template();
          }).elseIf(view_mode === 'page', () => {
            if (store.skip_mobile_project_mode) {
              return this.project_view_template();
            } else {
              return this.page_view_template();
            }
          }).else(() => {
            return this.project_view_template();
          })}
        </div>
      </header>
    `;
  }

  project_view_template() {
    const store = this.data.store;
    return Px.template`
      ${Px.if(!store.ui.share_view, () => {
        return Px.template`
          <button class="px-menu-button" data-onclick="openMobileMenu">
            <div class="px-icon">${Px.raw(MobileHeader.icons.menu)}</div>
          </button>
        `;
      })}
      ${Px.if(this.showSpinner, () => {
        return this.renderChild(Px.Components.Spinner, 'spinner');
      }).else(() => {
        if (store.cut_print_mode) {
          return Px.template`
            <div class="px-cut-prints-info">
              <h2>${this.cutPrintQuantityInfo}</h2>
              <p>${store.project.product_name}</p>
            </div>
          `;
        } else {
          return Px.template`
            <input class="px-project-name"
                  data-onchange="saveName"
                  data-onmouseup="selectIfDefault"
                  data-onfocusin="selectIfDefault"
                  data-onfocusout="resetNameIfEmpty"
                  value="${store.project.name}"
                  ${store.ui.share_view ? Px.raw('readonly="true"') : ''}
            />
          `;
        }
      })}
      ${Px.if(this.showCartButton, () => {
        return Px.template`
          <button class="px-mobile-cart-button" data-onclick="addToCart" ${this.isCartButtonDisabled ? 'disabled' : ''}>
            <div class="px-icon">${Px.raw(this.data.cart_icon)}</div>
            <div class="px-title">${Px.urlQuery().cart === 't' ? Px.t('Save to cart') : Px.t('Add to cart')}</div>
          </button>
        `;
      })}
    `;
  }

  page_view_template() {
    const store = this.data.store;
    return Px.template`
      <button data-onclick="deselectSet">
        <div class="px-icon">${Px.raw(MobileHeader.icons.project_view)}</div>
        <div class="px-title">${Px.t('Back')}</div>
      </button>
      ${Px.if(this.areLayoutsAvailable && !store.ui.share_view, () => {
        return Px.template`
          <button data-onclick="openLayoutsPanel">
            <div class="px-icon">${Px.raw(Px.Editor.Main.icons.layouts)}</div>
            <div class="px-title">${Px.t('Layouts')}</div>
          </button>
        `;
      })}
    `;
  }

  element_selection_template() {
    return Px.template`
      <div class="px-element-navigation">
        <button class="px-close"
                title="${Px.t('Back')}"
                data-onclick="deselectElement">
          <div class="px-icon">${Px.raw(MobileHeader.icons.cancel_cross)}</div>
        </button>
        <div class="px-elements-info">
          <span class="px-title">${this.availableItemsTitle}</span>
          <span class="px-subtitle">${this.selectedItemIndex + 1} / ${this.availableItems.length}</span>
        </div>
        <button class="px-prev"
                title="${Px.t('Previous')}"
                data-onclick="selectPrevItem"
                ${this.hasPrevItem ? '' : 'disabled'}>
          <div class="px-icon">${Px.raw(MobileHeader.icons.prev_arrow)}</div>
        </button>
        <button class="px-next"
                title="${Px.t('Next')}"
                data-onclick="selectNextItem"
                ${this.hasNextItem ? '' : 'disabled'}>
          <div class="px-icon">${Px.raw(MobileHeader.icons.next_arrow)}</div>
        </button>
      </div>
    `;
  }

  set_selection_template() {
    const store = this.data.store;
    return Px.template`
      <div class="px-set-selection">
        <button class="px-cancel-button"
                title="${Px.t('Cancel')}"
                data-onclick="exitSetSelection">
          <div class="px-icon">${Px.raw(MobileHeader.icons.cancel_cross)}</div>
        </button>
        <div class="px-page-count">${store.mobile.selected_page_count}</div>
      </div>
    `;
  }

  autofill_panel_template() {
    const store = this.data.store;
    return Px.template`
      <button class="px-close"
              title="${Px.t('Cancel')}"
              data-onclick="closeAutofillPanel">
        <div class="px-icon">${Px.raw(MobileHeader.icons.cancel_cross)}</div>
        <div class="px-title">${Px.t('Cancel')}</div>
      </button>
      ${Px.if(store.galleries.project.import_in_progress, () => {
        return this.renderChild(Px.Components.Spinner, 'spinner');
      }).else(() => {
        return Px.template`
          <div class="px-autofill-info">
            <span>${Px.t('Autofill Images')}</span>
            <span class="px-subtitle">${this.autofillImageCount} / ${this.availablePlaceholderCount}</span>
          </div>
        `;
      })}
      ${Px.if(store.mobile.selected_autofill_images.length > 0, () => {
        return Px.template`
          <button class="px-delete-button"
                  title="${Px.t('Remove')}"
                  data-onclick="removeSelectedAutofillImages">
            <div class="px-icon">${Px.raw(MobileHeader.icons.remove)}</div>
            <div class="px-title">${Px.t('Remove')}</div>
          </button>
        `;
      }).else(() => {
        return Px.template`
          <button class="px-autofill-button"
                  title="${Px.t('Autofill')}"
                  ${this.autofillButtonDisabled ? 'disabled' : ''}
                  data-onclick="runAutofill">
            <div class="px-icon">${Px.raw(MobileHeader.icons.cogs)}</div>
            <div class="px-title">${Px.t('Autofill')}</div>
          </button>
        `;
      })}
    `;
  }

  cut_print_quantity_selection_template() {
    return Px.template`
      <button class="px-close"
              title="${Px.t('Back')}"
              data-onclick="closeCutPrintQuantitySelection">
        <div class="px-icon">${Px.raw(MobileHeader.icons.project_view)}</div>
        <div class="px-title">${Px.t('Back')}</div>
      </button>
      <div class="px-cut-prints-info">
        <h2>${this.cutPrintQuantityInfo}</h2>
        <p>${Px.t('{{count}} photos').replace('{{count}}', this.cutPrintCount)}</p>
      </div>
      <div class="px-placeholder">
      </div>
    `;
  }

  element_edit_template() {
    return Px.template`
      <div class="px-element-edit">
        <button class="px-cancel-button"
                title="${Px.t('Cancel')}"
                data-onclick="cancelEdit">
          <div class="px-icon">${Px.raw(MobileHeader.icons.cancel_cross)}</div>
        </button>
        <div class="px-element-info">
          ${this.editItemTitle}
        </div>
        <button class="px-save-button"
                title="${Px.t('Save')}"
                ${this.data.store.mobile.has_changes_to_save ? '' : 'disabled'}
                data-onclick="saveEdit">
          <div class="px-icon">${Px.raw(MobileHeader.icons.checkmark)}</div>
          <div class="px-title">${Px.t('Save')}</div>
        </button>
      </div>
    `;
  }

  get dataProperties() {
    return {
      store: {required: true},
      cart_icon: {required: true},
      cart_callback: {required: true}
    };
  }

  static get computedProperties() {
    return Object.assign(super.computedProperties, {
      availableItemsTitle: function() {
        const store = this.data.store;
        if (store.cut_print_mode) {
          return Px.t('Photos');
        } else {
          const element_type = store.selected_element.type;
          if (element_type === 'image') {
            return Px.t('Images');
          } else if (element_type === 'text') {
            return Px.t('Texts')
          }
        }
      },
      hasPrevItem: function() {
        return this.selectedItemIndex >= 1;
      },
      hasNextItem: function() {
        return this.selectedItemIndex < this.availableItems.length - 1;
      },
      editItemTitle: function() {
        const store = this.data.store;
        const active_tool = store.mobile.active_tool;
        if (active_tool === 'page-layout-selector') {
          return Px.t('Set Layout');
        }
        const element_type = store.selected_element.type;
        if (element_type === 'image') {
          if (active_tool === 'image-crop-editor') {
            return Px.t('Crop Image');
          } else {
            return Px.t('Edit Image');
          }
        } else if (element_type === 'text') {
          return Px.t('Edit Text');
        }
      },
      availableItems: function() {
        const store = this.data.store;
        if (store.cut_print_mode) {
          return store.project.pages;
        } else {
          const element_type = store.selected_element.type;
          if (element_type === 'image') {
            return this.getEditableElements('image');
          } else if (element_type === 'text') {
            return this.getEditableElements('text');
          }
        }
      },
      selectedItemIndex: function() {
        const store = this.data.store;
        let selected_item;
        if (store.cut_print_mode) {
          selected_item = store.selected_page;
        } else {
          selected_item = store.selected_element;
        }
        return this.availableItems.findIndex(item => item === selected_item);
      },
      showCartButton: function() {
        const store = this.data.store;
        return store.resource_type === 'book' && !store.ui.share_view;
      },
      isCartButtonDisabled: function() {
        const store = this.data.store;
        return store.cut_print_mode && store.total_cut_print_quantity === 0;
      },
      cutPrintCount: function() {
        return this.data.store.project.cut_print_sets_with_definitions.length;
      },
      cutPrintQuantityInfo: function() {
        const store = this.data.store;
        const total_prints = store.total_cut_print_quantity;
        const max_prints = store.theme.max_cut_print_quantity;
        if (max_prints > 0) {
          let tpl = Px.t('{{count}}/{{max_count}} prints total');
          return tpl.replace('{{count}}', total_prints).replace('{{max_count}}', max_prints);
        } else {
          return Px.t('{{count}} prints total').replace('{{count}}', total_prints);
        }
      },
      areLayoutsAvailable: function() {
        const store = this.data.store;
        const layouts = store.layouts.layouts.filter(layout => {
          return store.selected_set.pages.some(page => {
            return layout.applicableToPage(page, store.options);
          });
        });
        return layouts.length > 0;
      },
      autofillImageCount: function() {
        return this.data.store.mobile.autofill_images.length;
      },
      autofillButtonDisabled: function() {
        return this.autofillImageCount === 0 || this.data.store.galleries.project.import_in_progress;
      },
      availablePlaceholderCount: function() {
        return this.data.store.project.fillable_placeholders.length;
      }
    });
  }

  // --------------
  // Event handlers
  // --------------

  deselectSet(evt) {
    const store = this.data.store;
    store.mobile.animate(() => store.selectSet(null));
  }

  deselectElement(evt) {
    this.data.store.selectElement(null);
  }

  cancelEdit(evt) {
    const mobile_store = this.data.store.mobile;
    mobile_store.animate(mobile_store.cancelEditMode);
  }

  saveEdit(evt) {
    const mobile_store = this.data.store.mobile;
    mobile_store.animate(mobile_store.endEditMode);
  }

  openMobileMenu(evt) {
    mobx.runInAction(() => {
      this.data.store.mobile.sidebar_active = true;
    });
  }

  addToCart(evt) {
    this.data.cart_callback();
  }

  selectPrevItem(evt) {
    if (this.hasPrevItem) {
      this.selectAvailableItem(this.selectedItemIndex - 1);
    }
  }

  selectNextItem(evt) {
    if (this.hasNextItem) {
      this.selectAvailableItem(this.selectedItemIndex + 1);
    }
  }

  exitSetSelection(evt) {
    this.data.store.mobile.selected_sets.clear();
  }

  openLayoutsPanel(evt) {
    const store = this.data.store;
    const page = store.selected_set.pages.find(page => {
      return store.layouts.layouts.some(layout => {
        return layout.applicableToPage(page, store.options);
      });
    });
    mobx.runInAction(() => {
      store.selectPage(page);
      store.mobile.setActiveTool('page-layout-selector');
      store.mobile.startEditMode();
    });
  }

  closeAutofillPanel(evt) {
    const mobile_store = this.data.store.mobile;
    mobile_store.animate(() => {
      mobile_store.clearAutofillImages();
      mobile_store.setActiveTool(null);
    });
  }

  removeSelectedAutofillImages(evt) {
    const mobile_store = this.data.store.mobile;
    mobx.runInAction(() => {
      mobile_store.selected_autofill_images.forEach(image => {
        mobile_store.removeAutofillImageId(image.id);
      });
    });
  }

  runAutofill(evt) {
    const store = this.data.store;
    const image_ids = store.mobile.autofill_images.map(image => image.id);
    const unfilled_image_ids = store.autofill(image_ids);
    mobx.runInAction(() => {
      store.mobile.clearAutofillImages();
      if (unfilled_image_ids.length > 0) {
        unfilled_image_ids.forEach(image_id => {
          store.mobile.addAutofillImageId(image_id);
        });
      } else {
        store.mobile.animate(() => {
          store.mobile.setActiveTool(null);
        });
      }
    });
  }

  closeCutPrintQuantitySelection(evt) {
    const store = this.data.store;
    mobx.runInAction(() => {
      store.cut_prints.deselectAll();
      store.mobile.setActiveTool(null);
    });
  }

  // -------
  // Private
  // -------

  selectAvailableItem(item_idx) {
    const item = this.availableItems[item_idx];
    const store = this.data.store;
    mobx.runInAction(() => {
      if (store.cut_print_mode) {
        store.selectSet(item.set);
        store.selectPage(item);
      } else {
        store.selectSet(item.page.set);
        store.selectElement(item);
      }
    });
  }

  getEditableElements(type) {
    const selected_set = this.data.store.selected_set;
    return selected_set.getElementsByType(type).filter(element => element.is_editable_master_element);
  }

};

Px.Editor.MobileHeader.icons = {
  menu: '<svg width="6" height="26" viewBox="0 0 6 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.64 3.78C3.2696 3.78 3.78 3.2696 3.78 2.64C3.78 2.0104 3.2696 1.5 2.64 1.5C2.0104 1.5 1.5 2.0104 1.5 2.64C1.5 3.2696 2.0104 3.78 2.64 3.78Z" fill="currentColor" stroke="currentColor" stroke-width="3" stroke-miterlimit="10"/><path d="M2.64 13.71C3.2696 13.71 3.78 13.1996 3.78 12.57C3.78 11.9404 3.2696 11.43 2.64 11.43C2.0104 11.43 1.5 11.9404 1.5 12.57C1.5 13.1996 2.0104 13.71 2.64 13.71Z" fill="currentColor" stroke="currentColor" stroke-width="3" stroke-miterlimit="10"/><path d="M2.64 23.63C3.2696 23.63 3.78 23.1196 3.78 22.49C3.78 21.8604 3.2696 21.35 2.64 21.35C2.0104 21.35 1.5 21.8604 1.5 22.49C1.5 23.1196 2.0104 23.63 2.64 23.63Z" fill="currentColor" stroke="currentColor" stroke-width="3" stroke-miterlimit="10"/></svg>',
  project_view: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><line x1="23" y1="12.5" x2="3" y2="12.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25"/><line x1="10.14" y1="21.07" x2="3" y2="12.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25"/><line x1="10.14" y1="3.93" x2="3" y2="12.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25"/></svg>',
  cancel_cross: '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polyline stroke-width="2" stroke-linecap="round" fill="none" stroke="currentColor" points="3,3 17,17" /><polyline stroke-width="2" stroke-linecap="round" fill="none" stroke="currentColor" points="3,17 17,3" /></svg>',
  checkmark: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><line x1="21.5" y1="2.5" x2="9.5" y2="20.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="3.38"/><line x1="3.5" y1="14.5" x2="9.5" y2="20.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="3.38"/></svg>',
  prev_arrow: '<svg width="12" height="20" viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg"><polyline stroke-width="2" stroke-linecap="round" fill="none" stroke="currentColor" points="11,1 2,10 11,19" /></svg>',
  next_arrow: '<svg width="12" height="20" viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg"><polyline stroke-width="2" stroke-linecap="round" fill="none" stroke="currentColor" points="1,1 10,10 1,19" /></svg>',
  remove: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M20,5.5V22.65a.86.86,0,0,1-.85.85H6.85A.86.86,0,0,1,6,22.65V5.5H20M21.5,4H4.5V22.65A2.36,2.36,0,0,0,6.85,25h12.3a2.36,2.36,0,0,0,2.35-2.35V4Z" stroke="none" stroke-width="0" fill="currentColor"/><line x1="3.5" y1="4.5" x2="22.5" y2="4.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="10.5" y1="9" x2="10.5" y2="21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="15.5" y1="9" x2="15.5" y2="21" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="8.75" y1="3.99" x2="10.49" y2="1.76" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line x1="15.3" y1="1.75" x2="10.5" y2="1.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.47"/><line x1="17.24" y1="4.23" x2="15.5" y2="2" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>',
  cogs: '<svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M28.8057 10.8179L28.3444 11.6278C28.1757 11.928 27.8157 12.0526 27.4951 11.9337C26.8313 11.6845 26.2238 11.3276 25.6894 10.8802C25.4307 10.6649 25.3632 10.2854 25.5319 9.9909L25.9932 9.18094C25.6051 8.72782 25.3013 8.20106 25.0988 7.62899H24.1707C23.8332 7.62899 23.5407 7.38543 23.4844 7.04559C23.3719 6.3659 23.3663 5.65223 23.4844 4.94422C23.5407 4.60438 23.8332 4.35516 24.1707 4.35516H25.0988C25.3013 3.78309 25.6051 3.25633 25.9932 2.80321L25.5319 1.99324C25.3632 1.69871 25.4251 1.31922 25.6894 1.10399C26.2238 0.656525 26.8369 0.299689 27.4951 0.0504705C27.8157 -0.0684748 28.1757 0.0561346 28.3444 0.35633L28.8057 1.16629C29.3963 1.05867 29.9982 1.05867 30.5888 1.16629L31.0501 0.35633C31.2188 0.0561346 31.5788 -0.0684748 31.8994 0.0504705C32.5632 0.299689 33.1707 0.656525 33.7051 1.10399C33.9638 1.31922 34.0313 1.69871 33.8626 1.99324L33.4013 2.80321C33.7894 3.25633 34.0932 3.78309 34.2957 4.35516H35.2238C35.5613 4.35516 35.8538 4.59871 35.9101 4.93856C36.0226 5.61824 36.0282 6.33192 35.9101 7.03992C35.8538 7.37977 35.5613 7.62899 35.2238 7.62899H34.2957C34.0932 8.20106 33.7894 8.72782 33.4013 9.18094L33.8626 9.9909C34.0313 10.2854 33.9694 10.6649 33.7051 10.8802C33.1707 11.3276 32.5576 11.6845 31.8994 11.9337C31.5788 12.0526 31.2188 11.928 31.0501 11.6278L30.5888 10.8179C30.0038 10.9255 29.3963 10.9255 28.8057 10.8179ZM28.2151 7.48739C30.3807 9.16395 32.8501 6.67742 31.1851 4.49676C29.0194 2.81453 26.5501 5.30672 28.2151 7.48739ZM21.7294 16.2044L23.6251 17.1559C24.1932 17.4845 24.4407 18.1811 24.2157 18.8042C23.7151 20.1749 22.7307 21.4323 21.8194 22.5311C21.4032 23.0352 20.6832 23.1598 20.1151 22.8313L18.4782 21.8798C17.5782 22.6557 16.5319 23.2731 15.3901 23.6753V25.5784C15.3901 26.2354 14.9232 26.8018 14.2819 26.9151C12.8982 27.153 11.4469 27.1643 10.0126 26.9151C9.36568 26.8018 8.88756 26.2411 8.88756 25.5784V23.6753C7.74568 23.2675 6.69943 22.6557 5.79943 21.8798L4.16256 22.8257C3.60006 23.1542 2.87443 23.0296 2.45818 22.5255C1.54693 21.4266 0.585055 20.1692 0.0844302 18.8042C-0.14057 18.1868 0.10693 17.4901 0.675055 17.1559L2.54818 16.2044C2.32881 15.0206 2.32881 13.8028 2.54818 12.6134L0.675055 11.6561C0.10693 11.3276 -0.146195 10.6309 0.0844302 10.0136C0.585055 8.64285 1.54693 7.38543 2.45818 6.2866C2.87443 5.7825 3.59443 5.65789 4.16256 5.98641L5.79943 6.93797C6.69943 6.16199 7.74568 5.54461 8.88756 5.14246V3.23367C8.88756 2.58231 9.34881 2.0159 9.99006 1.90262C11.3738 1.66473 12.8307 1.6534 14.2651 1.89696C14.9119 2.01024 15.3901 2.57098 15.3901 3.23367V5.1368C16.5319 5.54461 17.5782 6.15633 18.4782 6.93231L20.1151 5.98074C20.6776 5.65223 21.4032 5.77684 21.8194 6.28094C22.7307 7.37977 23.6869 8.63719 24.1876 10.0079C24.4126 10.6253 24.1932 11.322 23.6251 11.6561L21.7294 12.6077C21.9488 13.7972 21.9488 15.0149 21.7294 16.2044ZM15.1144 17.3995C18.4444 13.0382 13.5001 8.05946 9.16881 11.4126C5.83881 15.7739 10.7832 20.7526 15.1144 17.3995ZM28.8057 27.7477L28.3444 28.5577C28.1757 28.8579 27.8157 28.9825 27.4951 28.8636C26.8313 28.6143 26.2238 28.2575 25.6894 27.81C25.4307 27.5948 25.3632 27.2153 25.5319 26.9208L25.9932 26.1108C25.6051 25.6577 25.3013 25.1309 25.0988 24.5589H24.1707C23.8332 24.5589 23.5407 24.3153 23.4844 23.9755C23.3719 23.2958 23.3663 22.5821 23.4844 21.8741C23.5407 21.5343 23.8332 21.285 24.1707 21.285H25.0988C25.3013 20.713 25.6051 20.1862 25.9932 19.7331L25.5319 18.9231C25.3632 18.6286 25.4251 18.2491 25.6894 18.0339C26.2238 17.5864 26.8369 17.2296 27.4951 16.9804C27.8157 16.8614 28.1757 16.986 28.3444 17.2862L28.8057 18.0962C29.3963 17.9886 29.9982 17.9886 30.5888 18.0962L31.0501 17.2862C31.2188 16.986 31.5788 16.8614 31.8994 16.9804C32.5632 17.2296 33.1707 17.5864 33.7051 18.0339C33.9638 18.2491 34.0313 18.6286 33.8626 18.9231L33.4013 19.7331C33.7894 20.1862 34.0932 20.713 34.2957 21.285H35.2238C35.5613 21.285 35.8538 21.5286 35.9101 21.8684C36.0226 22.5481 36.0282 23.2618 35.9101 23.9698C35.8538 24.3097 35.5613 24.5589 35.2238 24.5589H34.2957C34.0932 25.1309 33.7894 25.6577 33.4013 26.1108L33.8626 26.9208C34.0313 27.2153 33.9694 27.5948 33.7051 27.81C33.1707 28.2575 32.5576 28.6143 31.8994 28.8636C31.5788 28.9825 31.2188 28.8579 31.0501 28.5577L30.5888 27.7477C30.0038 27.8554 29.3963 27.8554 28.8057 27.7477ZM28.2151 24.4116C30.3807 26.0882 32.8501 23.6016 31.1851 21.421C29.0194 19.7444 26.5501 22.2309 28.2151 24.4116Z" fill="currentColor"/></g><defs><clipPath id="clip0"><rect width="36" height="29" fill="white"/></clipPath></defs></svg>'
};
